export default __webpack_public_path__ + "static/media/shopping-cart.inline.d6e4cb57.svg";